export const LS_ITEM_LAST_HELP_REQUEST = 'lastHelpRequest';

// The cooldown period in milliseconds (1 day = 24 hours)
const HELP_REQUEST_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export const saveHelpRequestTimestamp = (): void => {
  try {
    const timestamp = new Date().getTime();
    localStorage.setItem(LS_ITEM_LAST_HELP_REQUEST, timestamp.toString());
  } catch (error) {
    console.error(error);
  }
};

export const hasRecentHelpRequest = (): boolean => {
  try {
    const lastRequestStr = localStorage.getItem(LS_ITEM_LAST_HELP_REQUEST);
    if (!lastRequestStr) return false;

    const lastRequestTime = parseInt(lastRequestStr);
    const currentTime = new Date().getTime();

    return currentTime - lastRequestTime < HELP_REQUEST_COOLDOWN_MS;
  } catch (error) {
    return false;
  }
};
